IN.App.SMSBaseController = Ember.Controller.extend({
	needs: ["login"],
	sendSMS: function () {
		var self = this;
		var loginController = this.get('controllers.login');
		var data = {
			email: loginController.get('email'),
			password: loginController.get('password')
		};
		
		$.post("/v1/auth/login", JSON.stringify(data), function(response) {
			
			
			
		}, "json");
	},
	actions: {
		sendsms: function(){
			this.sendSMS();
		}
	}
});